// @flow

import PropTypes from 'prop-types';
import ApiDcosxmlpath from '../../../data/cms/enums';
type Props = {
    ApiHelpName: String,
};
function GetXmlpath(props: Props) {
    var ApiHelpName = props;
    var XMLPath = '';
    switch (true) {
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsGetToken.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsGetToken;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsTaxSotware.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsTaxSotware;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsBinderTypes.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsBinderTypes;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsBinderTemplates.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsBinderTemplates;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsOfficeLocation.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsOfficeLocation;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsBinderList.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsBinderList;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsServiceType.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsServiceType;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsDRLCategories.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsDRLCategories;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsCreatenewBinder.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsCreatenewBinder;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsUploadBinder.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsUploadBinder;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsubmitBinder.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsubmitBinder;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocUpdateProject.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocUpdateProject;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsGetStatus.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsGetStatus;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsDocuments.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsDocuments;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsDownloadDocuments.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsDownloadDocuments;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsChangeBinderStatus.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsChangeBinderStatus;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsStatesandLocalities.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsStatesandLocalities;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsDownloadBinder.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsDownloadBinder;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsDownloadBinderPBFXSAML.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsDownloadBinderPBFXSAML;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsBinderStatuswithState.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsBinderStatuswithState;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsGetBinderDetails.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsGetBinderDetails;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsUnClearNotes.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsUnClearNotes;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsUnReviewedTRS.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsUnReviewedTRS;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsStickyNotes.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsStickyNotes;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsWorkPaperL1.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsWorkPaperL1;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsWorkPaperL2.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsWorkPaperL2;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsWorkPaperL3.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsWorkPaperL3;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsWorkPaperL4.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsWorkPaperL4;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsPendingReviewCount.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsPendingReviewCount;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsPendingSignature.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsPendingSignature;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsPendingUpload.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsPendingUpload;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsBinderAuditLog.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsBinderAuditLog;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsGetBinderInfo.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsGetBinderInfo;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsPushEngagementStatus.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsPushEngagementStatus;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsPushDocumentType.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsPushDocumentType;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsDocumentsUploaded.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsDocumentsUploaded;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsDRL.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsDRL;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsMiReports.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsMiReports;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsGetDRLOutput.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsGetDRLOutput;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsVer4gettoken.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsVer4gettoken;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsVer4TaxSoftware.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsVer4TaxSoftware;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsVer4BinderTypes.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsVer4BinderTypes;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsVer4ServiceTypes.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsVer4ServiceTypes;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsVer4BinderTemplates.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsVer4BinderTemplates;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsVer4OfficeLocations.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsVer4OfficeLocations;
        break;
    case ApiHelpName ===
            ApiDcosxmlpath.DocsVer4BinderStatusList.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsVer4BinderStatusList;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsVer4CreateNewBinder.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsVer4CreateNewBinder;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsVer4UploadBinderDocuments.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsVer4UploadBinderDocuments;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsVer4BinderSubmissionComplete.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsVer4BinderSubmissionComplete;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsVer4UpdateProjectID.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsVer4UpdateProjectID;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsVer4GetStatus.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsVer4GetStatus;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsVer4GetDocuments.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsVer4GetDocuments;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsVer4DownloadDocument.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsVer4DownloadDocument;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsVer4ChangeBinderStatus.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsVer4ChangeBinderStatus;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsVer4GetStatesandLocalities.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsVer4GetStatesandLocalities;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsVer4DownloadBinderPBFX.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsVer4DownloadBinderPBFX;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsVer4BinderStatuswithState.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsVer4BinderStatuswithState;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsVer4GetBinderDetails.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsVer4GetBinderDetails;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsVer4UnclearedNotes.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsVer4UnclearedNotes;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsVer4UnreviewedTRStamps.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsVer4UnreviewedTRStamps;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsVer4GetUnreviewedStickyNotes.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsVer4GetUnreviewedStickyNotes;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsVer4UnreviewedWorkpapersByL1.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsVer4UnreviewedWorkpapersByL1;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsVer4UnreviewedWorkpapersByL2.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsVer4UnreviewedWorkpapersByL2;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsVer4UnreviewedWorkpapersByL3.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsVer4UnreviewedWorkpapersByL3;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsVer4UnreviewedWorkpapersByL4.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsVer4UnreviewedWorkpapersByL4;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsVer4RequestedDocsPendingReview.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsVer4RequestedDocsPendingReview;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsVer4RequestedDocsPendingSignature.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsVer4RequestedDocsPendingSignature;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsVer4RequestedDocsPendingUpload.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsVer4RequestedDocsPendingUpload;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsVer4GetBinderPendingItems.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsVer4GetBinderPendingItems;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsVer4GetBinderAuditLog.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsVer4GetBinderAuditLog;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsVer4GetDRLOutput.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsVer4GetDRLOutput;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsVer4DRLCategories.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsVer4DRLCategories;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsUpdateOwnerMember.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsUpdateOwnerMember;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsAccountUsageHistory.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsAccountUsageHistory;
        break;
    case ApiHelpName.toLowerCase() ===
            ApiDcosxmlpath.DocsPrintBinder.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsPrintBinder;
        break;
    case ApiHelpName.toLowerCase() ===
        ApiDcosxmlpath.DocsCreateClient.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsCreateClient;
    break;
    case ApiHelpName.toLowerCase() ===
        ApiDcosxmlpath.DocsGetClientDetails.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsGetClientDetails;
    break;
    case ApiHelpName.toLowerCase() ===
        ApiDcosxmlpath.DocsCreateDrl.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsCreateDrl;
    break;
    case ApiHelpName.toLowerCase() ===
        ApiDcosxmlpath.DocsSendDrl.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsSendDrl;
    break;
    case ApiHelpName.toLowerCase() ===
        ApiDcosxmlpath.DocsClientSubscribe.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsClientSubscribe;
    break;
    case ApiHelpName.toLowerCase() ===
        ApiDcosxmlpath.DocsClientUnsubscribe.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsClientUnsubscribe;
    break; 
    case ApiHelpName.toLowerCase() ===
        ApiDcosxmlpath.DocsGetDRLPDFDetails .Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsGetDRLPDFDetails;
    break;
    case ApiHelpName.toLowerCase() ===
        ApiDcosxmlpath.DocsTaxcaddyDownloadDocument.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsTaxcaddyDownloadDocument;
    break;
    case ApiHelpName.toLowerCase() ===
    ApiDcosxmlpath.DocsTaxcaddyDisconnectDevices.Entity.toLowerCase():
    XMLPath = ApiDcosxmlpath.DocsTaxcaddyDisconnectDevices;
     break;
    case ApiHelpName.toLowerCase() ===
        ApiDcosxmlpath.DocsGetDRLStatus.Entity.toLowerCase():
        XMLPath = ApiDcosxmlpath.DocsGetDRLStatus;
    break;
    default:
        XMLPath = ApiDcosxmlpath.DocsVer4gettoken;
        break;
    }
    return XMLPath;
}

GetXmlpath.propTypes = {
    ApiHelpName: PropTypes.any,
};

export default GetXmlpath;
